<div class="terms-of-use" [class.popup]="isPopup" [class.arabic-content]="textDirection === 'rtl'">
  @if (isLoading) {
    <div class="loader-container">
      <img class="spin-loader" src="assets/images/loader-icon.gif" alt="Loading terms of use" />
    </div>
  } @else {
    <div class="container">
      <div
        [innerHTML]="
          textDirection === 'rtl'
            ? sanitizerContent(content?.contentAr)
            : sanitizerContent(content?.contentEn)
        "
      ></div>
    </div>
  }
</div>
